export default "__VITE_ASSET__9b534b09__"